// extracted by mini-css-extract-plugin
module.exports = {"group_container":"InputGroup_group_container__14pjh","group_label":"InputGroup_group_label__3O5LD"};